import * as utils from '../utils';
export function getInitializer(node) {
    return utils.getValueOrUndefined(node.initializer);
}
export function getInitializerOrThrow(node) {
    return utils.throwIfNullOrUndefined(getInitializer(node), 'initializer');
}
export function hasInitializer(node) {
    return getInitializer(node) !== undefined;
}

//# sourceMappingURL=initializer.js.map
